export default __webpack_public_path__ + "static/media/Bradley.c140bbc7.eot";